import { ClientSwitcher } from "@service/api-client/client-switcher";
var BetTournamentsRequestField = /* @__PURE__ */ ((BetTournamentsRequestField2) => {
  BetTournamentsRequestField2["tournaments"] = "tournaments";
  BetTournamentsRequestField2["leaderboards"] = "leaderboards";
  BetTournamentsRequestField2["users"] = "users";
  BetTournamentsRequestField2["authorizedUsers"] = "authorizedUsers";
  return BetTournamentsRequestField2;
})(BetTournamentsRequestField || {});
class BetTournamentsClient extends ClientSwitcher {
  constructor() {
    super(...arguments);
    this.baseUrl = "api/tournaments/bet-tournament";
    this.betTournamentApi = {
      getBetTournaments: `${this.baseUrl}/get-active`,
      getIsParticipate: `${this.baseUrl}/participation-info`,
      changeParticipationStatus: `${this.baseUrl}/change-participation-status`,
      getBetTournamentsV2: "api/v2/tournaments/bet-tournament/get-active"
    };
  }
  getBetTournaments(params) {
    return this.get(this.betTournamentApi.getBetTournamentsV2, params);
  }
  getIsParticipate(params) {
    return this.get(this.betTournamentApi.getIsParticipate, params);
  }
  changeParticipationStatus(params) {
    return this.post(
      this.betTournamentApi.changeParticipationStatus,
      params,
      null
    );
  }
}
export {
  BetTournamentsClient,
  BetTournamentsRequestField
};
